module.exports = __webpack_public_path__ + "static/img/school-3.9f294de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-3.png
// module id = Hgqk
// module chunks = 0